export default __webpack_public_path__ + "static/media/Karnataka3.33c36577.png";